import { useState } from "react";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Carousel = () => {

    const [slideIndex, setSlideIndex] = useState(0)

    const setting = {
        dots: true,
        infinite: true,
        speed: 3000,
        slidesToShow: 3,
        slidesToScroll:1,
        autoplay: true, 
        autoplaySpeed: 1500,
        beforeChange : (current, next) => setSlideIndex(next),
        centerMode: true
        
    }

    const carouselData = [
        {
            name: 'Subiantoro Tjandra',
            company: 'Kencana Sakti Printing',
            description: 'Bagus. SATSET Langsung dianter'
        },
        {
            name: 'Agus Jazuli',
            company: 'HMS',
            description: 'Toner sudah diterima tgl 9, terima kasih supportnya'
        },
        {
            name: 'Irman Irmawan',
            company: 'Niki',
            description: 'mantap... AA nya ramah.. sudah oke mesin lancar.'
        },
        {
            name: 'Dicky Natanael',
            company: 'Kantor OJK Provinsi Jambi',
            description: 'Respon cukup cepat dan Teknisi mudah diajak berkoordinasi.'
        },
        {
            name: 'Mohammad Edo Agustono',
            company: 'Soerabaja Printing Indonesia',
            description: 'Orderan sesuai dengan setimasi waktu 3 hari sudah sampai. 2 toner yellow & magenta'
        },
        {
            name: 'SMKN 1 Payakumbuh',
            company: 'SMKN 1 Payakumbuh',
            description: 'Selalu puas dengan pelayanan yang diberikan.'
        },
    ]

    return (
        <Slider {...setting}>
            { carouselData.map((val, key) => {
                return(
                    <div className={ `card slide-card shadow-lg`} key={key}>
                        <div className="card-body d-flex align-items-center justify-content-center" style={{padding:'1rem'}}>
                            <div className="text-center">
                                <div className="col-12 text-center fs-5">
                                    <i className="fa fa-star text-warning"></i>
                                    <i className="fa fa-star text-warning"></i>
                                    <i className="fa fa-star text-warning"></i>
                                    <i className="fa fa-star text-warning"></i>
                                    <i className="fa fa-star text-warning"></i>
                                </div>
                                <p className="description-rating fst-italic" style={{fontSize:'14px', marginBottom:'180px'}}> { val.description} </p>
                                <h5 className="name-cust fw-bold"> {val.name} </h5>
                                <p className="text-secondary-body fw-medium" style={{fontSize:'14px', color:'#bfbfbf'}}> {val.company} </p>
                            </div>
                        </div>
                    </div>
                )
            })}
        </Slider>
    )
}

export default Carousel

